import React, {Component} from "react";
import {connect} from "react-redux";
import Loading from "../shared/Loading";
import {countryList, editAccount, removeCard, uploadProfilePhoto} from "../../utils/API";
import Objects from "../../redux/Objects";
import {set} from "../../redux/Action";
import {history} from "../../history/History";
import Selectbox from "../utils/Selectbox";
import UploadImage from "../shared/UploadImage";
import {educationLevels, idTypes} from './Register'
import {runAfterLoadSession} from "../../utils/Utility";
import store from "../../redux/Store";
import {sessionUpdate} from "../../history/Session";
import {show} from "../../utils/Toast";
import {CardElement, Elements, ElementsConsumer} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import QuestionModal from "../utils/QuestionModal";

const stripePromise = loadStripe('pk_live_4C1NJaevrhgUgFm14yyTLlzS');

class Profile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            registerApi: false,
            countryList: [],
            country: undefined,
            educationLevel: undefined,
            profilePhoto: undefined,
            idType: undefined,
            idPhoto: undefined,
            showRemoveCard: false,
            editCard: false,
            removeCardApi: false,
        }
    }


    componentDidMount() {
        runAfterLoadSession(() => {
            this.setState({
                educationLevel: educationLevels[this.props.profile.educationLevelOrdinal],
                profilePhoto: this.props.profile.profilePhotoUrl,
                idType: this.props.profile.idTypeOrdinal !== undefined ? idTypes[this.props.profile.idTypeOrdinal] : undefined,
                idPhoto: this.props.profile.idPhotoUrl,
                editCard: !this.props.profile.haveCard
            })
            countryList((res) => {
                this.setState({
                    countryList: res,
                    country: res.filter(c => c.name === this.props.profile.countryName)[0]
                })
            })
        })
    }

    editProfile = async (ctx) => {
        let pm;
        if (ctx && this.state.editCard) {
            const {elements, stripe} = ctx;
            const cardElement = elements.getElement(CardElement);

            if (!stripe || !elements) {
                show('Payment method is not available')
                return;
            }
            this.setState({registerApi: true})
            const {error, paymentMethod} = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });

            if (error) {
                // this.setState({registerApi: false})
                show(error.message)
                // return
            } else {
                pm = paymentMethod;
            }
        }
        console.log(pm)
        let param = {
            educationLevel: this.state.educationLevel.id,
            country: this.state.country.id,
            tutor: this.props.profile.tutor,
        }
        if (this.state.profilePhoto !== this.props.profile.profilePhotoUrl)
            param = {
                ...param,
                profilePhotoUrl: this.state.profilePhoto,
            }
        if (param.tutor) {
            param = {
                ...param,
                idType: this.state.idType.id,
            }
            if (this.state.idPhoto !== this.props.profile.idPhotoUrl)
                param = {
                    ...param,
                    idPhotoUrl: this.state.idPhoto,
                }
        }
        if (pm) {
            param = {
                ...param,
                pmToken: pm.id
            }
        }

        editAccount(param, (res) => {
            store.dispatch(set(Objects.profile, res))
            sessionUpdate(Objects.profile, res)
            this.setState({registerApi: false})
            show("Profile updated")
            history.goBack()
        }, () => {
            this.setState({registerApi: false})
        })
    }

    removeCardMethod = () => {
        this.setState({removeCardApi: true})

        removeCard((res) => {
            store.dispatch(set(Objects.profile, res))
            sessionUpdate(Objects.profile, res)
            this.setState({
                removeCardApi: false,
                showRemoveCard: false,
                editCard: true,
            })
            show("Card removed successfully")
        }, () => {
            this.setState({removeCardApi: false})
        })
    }

    render() {
        return (

            <div className="contain-app">
                <div className="logo">
                    {/*<img alt="logo"/>*/}
                </div>

                <button className="back-btn" onClick={() => history.goBack()}>
                    <i className="icon-arrow_back_ios"/>
                </button>
                {this.props.profile &&<div className="body-login">
                    <div>
                        <h4>Profile</h4>

                        <h5 className="bold mt-5">General Information</h5>
                        <Selectbox items={this.state.countryList}
                                   className="select-tutorfest mb-3"
                                   activeClassName="active"
                                   value={this.state.country}
                                   defaultTitle="Choose country"
                                   onSelect={(item) => this.setState({country: item})}
                        />
                        <Selectbox items={educationLevels}
                                   className="select-tutorfest mb-3"
                                   activeClassName="active"
                                   value={this.state.educationLevel}
                                   defaultTitle="Choose education level"
                                   onSelect={(item) => this.setState({educationLevel: item})}
                        />
                        <UploadImage id="profile"
                                     withCrop
                                     aspect={1}
                                     initialWidth={40}
                                     onComplete={(image) => {
                                         uploadProfilePhoto(image, (res) => {
                                             this.setState({profilePhoto: res.data.data})
                                         })
                                     }}
                        >
                            <div className="upload-image-photo">
                                <span>{this.state.profilePhoto ? 'Profile photo Uploaded' : 'Upload profile photo'}</span>
                                {this.state.profilePhoto && <i className="icon-checkmark-outline ml-3"/>}
                            </div>
                        </UploadImage>
                        {this.props.profile.tutor && <Selectbox items={idTypes}
                                                                className="select-tutorfest mb-3"
                                                                activeClassName="active"
                                                                value={this.state.idType}
                                                                defaultTitle="Choose ID type"
                                                                onSelect={(item) => this.setState({idType: item})}
                        />}

                        {this.props.profile.tutor && <UploadImage id="idType"
                                                                  onComplete={(image) => {
                                                                      uploadProfilePhoto(image, (res) => {
                                                                          this.setState({idPhoto: res.data.data})
                                                                      })
                                                                  }}
                        >
                            <div className="upload-image-photo">
                                <span>{this.state.idPhoto ? 'ID photo Uploaded' : 'Upload ID photo'}</span>
                                {this.state.idPhoto && <i className="icon-checkmark-outline ml-3"/>}
                            </div>
                        </UploadImage>}

                        <div>
                            <h5 className="bold mt-5">Payment Information</h5>
                            {
                                !this.state.editCard && <div className="mt-2 mb-3">
                                    {this.props.profile.last4Card && <span className="text-center mb-1">Your card: ************{this.props.profile.last4Card}</span>}
                                    <button
                                        onClick={() => this.setState({showRemoveCard: true})}
                                        className="mt-3 waves-effect waves-light btn red mr-2 no-uppercase bold">
                                        <span className="white-text">Remove Card</span>
                                    </button>
                                    <button
                                        onClick={() => this.setState({editCard: true})}
                                        className="mt-3 waves-effect waves-light btn white no-uppercase bold">
                                        <span>Edit Card</span>
                                    </button>

                                </div>
                            }
                            {this.state.editCard && <Elements stripe={stripePromise}>
                                <ElementsConsumer>
                                    {(ctx) => <div>
                                        <CardElement id="" options={{
                                            style: {
                                                base: {
                                                    backgroundColor: '#000',
                                                    padding: '10px',
                                                    color: '#fff',
                                                    fontSize: "18px",
                                                    "::placeholder": {
                                                        color: "#fff"
                                                    }
                                                }
                                            }
                                        }}/>
                                        <div className="mt-3" style={{
                                            borderTop: '1px solid #ced4da',
                                        }}>
                                            <button
                                                onClick={() => this.editProfile(ctx)}
                                                disabled={this.state.registerApi}
                                                className="mt-3 waves-effect waves-light btn-large white w-100 no-uppercase bold">
                                                <Loading show={this.state.registerApi}>
                                                    <span>Update</span>
                                                </Loading>
                                            </button>
                                        </div>
                                    </div>}
                                </ElementsConsumer>
                            </Elements>}
                        </div>
                        {!this.state.editCard && <button
                            onClick={this.editProfile}
                            disabled={this.state.registerApi}
                            className="mt-3 waves-effect waves-light btn-large white w-100 no-uppercase bold">
                            <Loading show={this.state.registerApi}>
                                <span>Update</span>
                            </Loading>
                        </button>}
                    </div>
                </div> }
                <QuestionModal show={this.state.showRemoveCard}
                               onHide={() => this.setState({showRemoveCard: false})}
                               acceptTitle="Yes"
                               rejectTitle="No"
                               onReject={() => this.setState({showRemoveCard: undefined})}
                               hideButton={this.state.removeCardApi}
                               onAccept={this.removeCardMethod}
                >
                    <div className="text-center p-3">
                        <span>Are you sure about removing your card ? You cannot submit a new request without having a card</span>
                    </div>
                </QuestionModal>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
